if (!customElements.get('predictive-search')) {  
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.isInit = false;
      this.searchInput = null;
      this.emptyResults = false;
      this.indexPrefix = this.dataset.prefix;
      this.headerIndex = `${this.indexPrefix}products_header_search${getSuffix()}`;
      this.querySuggestions = `${this.indexPrefix}products_query_suggestions${getSuffix()}`;
      this.queryCollections = `shopify_collections`;
      this.lastRenderedQuery = null;
      this.searchDebounceTimer = null;
      this.debounceDelay = 350; // ms
      this.turbolinkUrl = null;
    }

    connectedCallback() {
      if (this.isInit) return;
      this.init();
    }
    
    init() {
      if (this.isInit) return;     
      this.isInit = true;
      this.addDelegatedClickListeners();
    }
    
    addDelegatedClickListeners() {
      document.addEventListener('keydown', async (e) => {
        if (this.isOpen && e.key === 'Enter' && this.searchInput && e.target === this.searchInput) {
          const query = this.searchInput.value?.trim();
          if (!query) return;

          if (this.turbolinkUrl && this.lastRenderedQuery === query) {
            e.preventDefault();
            window.location.href = this.turbolinkUrl;
            return;
          }
          e.preventDefault();
          clearTimeout(this.searchDebounceTimer);
          await this.fetchSearchResults(query);

          if (this.turbolinkUrl) {
            window.location.href = this.turbolinkUrl;
          } else {
            window.location.href = `/search?q=${encodeURIComponent(query)}`;
          }
        }
      });

      document.addEventListener('keyup', (e) => {
        if (this.isOpen && e.key === "Escape") {
          this.close();
          return;
        }

        if (this.isOpen && this.searchInput && e.target === this.searchInput) {
          clearTimeout(this.searchDebounceTimer);
          this.searchDebounceTimer = setTimeout(() => {
            this.fetchSearchResults(this.searchInput.value);
          }, this.debounceDelay);
        }
      });
      
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-search-toggle="close"]')) {
          this.close();
          return;
        }

        if (e.target.closest('predictive-search')) return;
        
        if (e.target.closest('[data-search-toggle="open"]')) {
          this.searchInput = e.target.closest('[data-search-toggle="open"]');
          this.open();
          const currentValue = this.searchInput?.value || '';

          if (this.lastRenderedQuery !== currentValue) {
            this.fetchSearchResults(currentValue);
          }

          this.emptyResults = true;
          return;
        }
        
        this.close();
      });

      document.addEventListener('focusin', (e) => {
        if (!this.isOpen) return;
        if (!this.searchInput) return;
        if (e.target !== this.searchInput) return;

        const currentValue = this.searchInput.value || '';
        if (this.lastRenderedQuery !== currentValue) {
          this.fetchSearchResults(currentValue);
        }
      });

      this.addEventListener('click', (e) => {
        const anchor = e.target.closest('[href]');
        
        if (anchor?.closest('[data-popular-product]')) {
          e.preventDefault();
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.AutocompletePopularClicked,
            data: {
              query: this.lastRenderedQuery, // (Required)
              term: anchor.innerText // (Required)
            }
          });
          
          window.location.href = anchor.href;
          return;
        }
        
        if (anchor && anchor.closest('[data-fs-product]') && anchor.closest('[data-fs-s]')) {
          e.preventDefault();
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.AutocompleteProductClicked,
            data: {
              kl_id: this.klaviyoID,
              query: this.lastRenderedQuery,
              productID: anchor.dataset.fsId,
              productQuery: anchor.dataset.fsS
            }
          });
          
          window.location.href = anchor.href;
          return;
        };
        
        if (anchor && anchor.closest('[data-collection-id]')) {
          e.preventDefault();
          window.FastSimonSDK.event({
            eventName: window.FastSimonEventName.AutocompleteCategoryClicked,
            data: {
              kl_id: this.klaviyoID,
              query: this.lastRenderedQuery,
              collectionID: `/collections/${anchor.closest('[data-collection-id]').dataset.collectionId}`,
            }
         });
         
         window.location.href = anchor.href;
         return;
        };        
      });
    }
    
    
    open() {
      if(this.isOpen) return
      this.isOpen = true;
      this.classList.remove('hidden');
      document.body.classList.add('scroll-lock', 'overlay-search');
      document.querySelector('[data-main-nav]')?.classList.add('overlay', 'blur');
      document.querySelector('site-header')?.closeAllMenus();
      
      const searchWrapper = this.querySelector('[data-search-wrapper]');
      searchWrapper.style.top = `${Math.ceil(this.searchInput.getBoundingClientRect()?.bottom)}px`;
      document.querySelector('[data-mobile-overlay]')?.classList.add('open-on-mobile');

      setTimeout(() => {
        this.classList.add('active');
        if (window.matchMedia('(max-width: 768px)').matches) {
          document.querySelector('input[name="q"]')?.focus().setSelectionRange(0, 999);
        }
      }, 100);

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = '-1';
      
      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = '-1';
      // });
    }

    close() {
      document.body.classList.remove('scroll-lock', 'overlay-search');
      this.isOpen = false;
      this.classList.remove('active');
      document.querySelector('[data-mobile-overlay]')?.classList.remove('open-on-mobile');
      document.querySelector('[data-main-nav]')?.classList.remove('blur');
      document.documentElement.classList.remove('cloud-search-mobile-open');

      setTimeout(() => {
        this.classList.add('hidden');
        document.querySelector('[data-main-nav]')?.classList.remove('overlay');
      }, 501);

      let submenu_open = false;
      const submenu_buttons = document.querySelectorAll('[data-action="open-submenu"]');

      submenu_buttons.forEach(button => {
        if (button.classList.contains('active')) submenu_open = true;
      });

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = submenu_open ? '-1' : '31';
      
      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = submenu_open ? '-1' : '31';
      // });
    }
    
    buildResultsPane(products, querySuggestions, query, collections, hits) {
      const searchWrapper = this.querySelector('[data-search-wrapper]');
      const popularSearches = this.querySelector('[data-popular-searches]');
      const collectionResults = this.querySelector('[data-collection-results]');
      const searchResults = this.querySelector('[data-search-results]');
      const searchCount = this.querySelector('[data-search-count]');
      const viewLabel = this.dataset.viewLabel;
      if (query) {
        searchWrapper.classList.add('has-results');
        searchCount.innerHTML = `(${hits})`;
      } else {
        searchWrapper.classList.remove('has-results');
        searchCount.innerHTML = '';
      }
      
     
      popularSearches.innerHTML = `
       ${ querySuggestions.length ?
          `<ul class="flex flex-col gap-4">
            ${querySuggestions.map((suggestion) => `
              <li class="leading-5" data-popular-product>
                <a class="no-underline text-primaryDark hover:text-primaryBrand" href="${suggestion.url || `/search?q=${suggestion.query}`}">
                  ${suggestion.query}
                </a>
              </li>
            `).join('')}
          </ul>` 
          : `<p class="text-gray-500">No suggestions found.</p>`
        }`;


        const filteredCollections = (collections || []).filter(
          (collection) => !collection.handle.includes('-colors')
        );

        if (filteredCollections.length) {
          searchWrapper.classList.remove('no-collection');
          collectionResults.innerHTML = `
            <ul class="flex flex-col gap-4">
              ${filteredCollections.map((collection) => `
                <li class="leading-5" data-collection-id="${collection.handle}">
                  <a class="no-underline text-primaryDark hover:text-primaryBrand" href="/collections/${collection.handle}">
                    ${collection.title}
                  </a>
                </li>
              `).join('')}
            </ul>
          `;
        } else {
          searchWrapper.classList.add('no-collection');
          collectionResults.innerHTML = '';
        }

      
      searchResults.innerHTML = `
        ${query ? 
          `<div class="flex flex-col gap-5">
            <ul class="gap-2 grid grid-cols-2 md:grid-cols-4 max-w-[1400px]">
              ${products.filter(p => p.t !== null || p.t2 !== null).slice(0, 4).map((product) => `
                <li 
                  class="bg-primaryLight rounded-md overflow-hidden aspect-[224/284] [&_product-mini-tile]:h-full [&_[data-product-url]]:justify-between [&_[data-product-url]]:h-full"
                  data-fs-s="${product.s}" 
                  data-fs-id="${product.id}"   
                >
                  <intersection-loader
                    data-url="${product.u}"
                    data-section-id="product-mini-tile"
                    data-hide-parent-on-empty
                    class="aspect-[224/284]"
                  ></intersection-loader>
                </li>
              `).join('')} 
            </ul>
            <a href="/search?q=${query}" class="max-md:hidden button-primary no-underline w-fit flex">${viewLabel}</a>
          </div>` : 
          this.querySelector('[data-trending-tiles]').innerHTML
        }
      `;
    }
    
    async fetchSearchResults(query) {
      const q = query ?? '';

      const waitForFS = () => new Promise((resolve) => {
        if (window.FastSimonSDK) return resolve();
        const interval = setInterval(() => {
          if (window.FastSimonSDK) {
            clearInterval(interval);
            resolve();
          }
        }, 50);
      });

      await waitForFS();

      const payload = await new Promise((resolve) => {
        window.FastSimonSDK.instantSearch({
          query: q,
          callback: (res) => resolve(res?.payload || null)
        });
      });

      if (!payload) return;

      const products = payload.products || [];
      const baseProductCount = products.filter(p => p.t === null && p.t2 === null).length;
      const hits = Math.max(0, Number(payload.total_results || payload.totalResults || 0) - baseProductCount);
      const responseQuery = payload.query ?? q;
      const turbolinks = payload.turbolinks || [];
      const exactTurbolink = turbolinks.find((t) => (t?.l || t?.label || '').toLowerCase() === q.toLowerCase());
      this.turbolinkUrl = exactTurbolink?.u || null;

      const rawSuggestions = [
        ...(payload.popularSearches || []),
        ...turbolinks
      ];

      const querySuggestions = rawSuggestions
        .map((s) => ({
          query: typeof s === 'string' ? s : (s?.l || s?.label || s?.query || ''),
          url: typeof s === 'string' ? null : (s?.u || null)
        }))
        .filter((x) => x.query);

      const collections = (payload.categories || []).map((c) => {
        const url = c?.u || '';
        const handle = url.includes('/collections/')
          ? url.split('/collections/')[1].split('?')[0].split('#')[0]
          : '';

        return {
          handle,
          title: c?.l || ''
        };
      }).filter((c) => c.handle && c.title);

      if (!this.defaultProducts) this.defaultProducts = products;

      if (!products.length) {
        this.buildResultsPane(this.defaultProducts || [], querySuggestions, responseQuery, collections, hits);
        return;
      }

      if (products.length < 3 && this.defaultProducts?.length) {
        this.buildResultsPane([...products, ...this.defaultProducts], querySuggestions, responseQuery, collections, hits);
        return;
      }

      this.buildResultsPane(products, querySuggestions, responseQuery, collections, hits);
      this.lastRenderedQuery = responseQuery;
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}